<template>
  <v-row align="center" justify="center">
    <v-col cols="12">
      <v-card elevation="0" tile>
        <v-card-title class="grey lighten-4">
          {{ $t("hr.menu.imprest") }}
          <v-spacer />

          <id-button class="mr-2" @click="onCreate">
            <template #icon>
              <v-icon left>mdi-plus</v-icon>
            </template>
            {{ $t("buttons.add_imprest") }}
          </id-button>
          <id-button @click="onRefreshData">
            <template #icon>
              <v-icon left>mdi-refresh</v-icon>
            </template>
            {{ $t("buttons.refresh") }}
          </id-button>
        </v-card-title>
        <v-data-table
          :headers="table.headers"
          :items="table.data"
          :options.sync="table.options"
          :server-items-length="table.totalItems"
          single-select
          class="elevation-1"
          :loading="table.loading"
          :footer-props="{ 'items-per-page-options': [10, 25, 50, 100] }"
        >
          <template slot="item" slot-scope="row">
            <tr :active="row.selected">
              <td>{{ $helpers.getConvertCurrency(row.item.requested) }}</td>
              <td>
                {{ row.item.period | formattedDate }}
              </td>

              <td>{{ row.item.reason }}</td>
              <td>
                <template v-if="row.item.travel">
                  <p class="ma-0 caption">
                    <v-icon size="20" color="teal">mdi-account</v-icon>
                    {{ row.item.travel.employee.firstName }} {{ row.item.travel.employee.lastName }}
                  </p>
                  <p class="ma-0 caption">
                    <v-icon size="20" color="teal">mdi-map-marker</v-icon>{{ row.item.travel.address }}
                  </p>
                  <p class="ma-0 caption">
                    <v-icon size="20" color="teal">mdi-calendar-range</v-icon>
                    {{ row.item.travel.beginDate | formattedDateTimeMinute }} -
                    {{ row.item.travel.endDate | formattedDateTimeMinute }}
                  </p>
                </template>
                <v-icon v-else color="red">mdi-close</v-icon>
              </td>
              <td>
                <template v-if="row.item.expenseManagement">
                  <p class="ma-0">
                    {{ row.item.expenseManagement.name }}
                  </p>
                  <p v-if="row.item.expenseManagement.project" class="ma-0 caption">
                    <v-avatar size="14" :color="row.item.expenseManagement.project.color" />
                    {{ row.item.expenseManagement.project.name }}
                  </p>
                </template>
                <v-icon v-else color="red">mdi-close</v-icon>
              </td>
              <td>
                <request-status-label :status="row.item.requestStatus" />
              </td>
            </tr>
          </template>
        </v-data-table>
        <transition name="slide-in-left">
          <router-view @success:save="onRefreshData" />
        </transition>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
  /**
   * @project personal-idenfit
   * @developer Halil Kılıçarslan
   * @description Performance Component Logic
   * @date 28.07.2020
   */

  import { PAGINATE } from "./query";
  import RequestStatusLabel from "@/components/global/request-status-label";

  export default {
    name: "Imprest",
    components: { RequestStatusLabel },
    data: vm => ({
      table: {
        loading: false,
        data: [],
        criteria: {
          employee: null
        },
        options: {},
        pagination: {
          rowsPerPage: 50,
          sortBy: "createdDateTime",
          descending: true
        },
        totalItems: 0,
        totalPages: 0,
        selected: [],
        headers: [
          {
            text: vm.$t("hr.imprest.amount"),
            value: "amount",
            align: "left",
            sortable: true,
            class: ["primary--text"]
          },
          {
            text: vm.$t("hr.imprest.period"),
            value: "period",
            align: "left",
            sortable: true,
            class: ["primary--text"]
          },
          {
            text: vm.$t("hr.imprest.reason"),
            value: "total",
            align: "left",
            sortable: true,
            class: ["primary--text"]
          },
          {
            text: vm.$t("hr.expense.travel"),
            value: "",
            align: "left",
            sortable: false,
            class: ["primary--text"]
          },
          {
            text: vm.$t("global.expense_management"),
            value: "",
            align: "left",
            sortable: false,
            class: ["primary--text"]
          },
          {
            text: vm.$t("hr.imprest.status"),
            value: "requestStatus",
            align: "left",
            sortable: true,
            class: ["primary--text"]
          }
        ]
      }
    }),
    watch: {
      "table.options": {
        handler(options) {
          let { itemsPerPage, page } = options;
          this.table.pagination.rowsPerPage = itemsPerPage;
          this.table.pagination.page = page;
          this.table.criteria.employee = this.$store.state.auth.user.id;
          this.table.criteria.beginDate = this.$moment()
            .startOf("month")
            .format("YYYY-MM-DD");
          this.table.criteria.endDate = this.$moment()
            .endOf("month")
            .format("YYYY-MM-DD");
          this.fetchItems();
        },
        deep: true
      }
    },
    methods: {
      onRefreshData() {
        this.fetchItems();
      },
      async fetchItems() {
        this.table.loading = true;
        await this.$apollo
          .query({
            query: PAGINATE,
            variables: {
              criteria: this.table.criteria,
              pagination: this.$helpers.convertPagination(this.table.pagination)
            }
          })
          .then(({ data, errors }) => {
            if (!errors || !data.error) {
              this.table.data = data.filterWithPaginateImprests.content || [];
              this.table.totalItems = data.filterWithPaginateImprests.pageInfo.totalElements || 0;
            }
          })
          .catch(e => {
            this.$helpers.showNotification(e.message);
          })
          .finally(() => (this.table.loading = false));
      },
      onCreate() {
        this.$router.replace({ name: "imprest_create" });
      }
    }
  };
</script>

<style scoped></style>
